import styled from "styled-components";
import media from "styled-media-query";

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const BlocContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 32px;
`;

export const UrgencyCardContainer = styled.div<{ isLast: boolean }>`
  width: ${({ isLast }) => (isLast ? "100%" : "49.7%")};
  margin-bottom: 8px;

  ${media.lessThan("small")`
    width:100%
  `}
`;
